<template>
    <div class="addBag acccont">
        <div class="acctit">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            {{usefunc=='add'?$t('account.wallet_add'):$t('account.wallet_edit')}}
        </div>
        <div>
            <div class="texac">
                <div class="formbox">
                    <el-form :model="ruleForm" ref="ruleForm" label-width="120px">
                        <el-form-item :label="$t('account.wallet_type')">
                            <el-select v-model="ruleForm.type" class="selebox"
                                       :placeholder="$t('account.select_wallet_type')">
                                <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('account.wallet_address')">
                            <el-input prefix-icon="el-icon-location" v-model="ruleForm.address"
                                      :placeholder="$t('account.input_wallet_address')" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.trader_password')">
                            <el-input prefix-icon="el-icon-key" type="password" v-model="ruleForm.pay_password"
                                      :placeholder="$t('account.input_trader_password')" autocomplete="off"></el-input>
                        </el-form-item>
                        <div class="btnn bgb texac" @click="submitForm">{{$t('account.save')}}</div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {getInfo, addOrUpdate} from '@/api/wallet'

    export default {
        name: 'addBag',
        data() {
            return {
                id: 0,
                usefunc: '',
                ruleForm: {
                    id: 0,
                    type: null,
                    address: '',
                    pay_password: ''
                },
                options: [{
                    value: '1',
                    label: 'ERC20'
                }, {
                    value: '2',
                    label: 'TRC20'
                }],
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        mounted() {
            this.usefunc = this.$route.query.usefun
            this.id = this.$route.query.id
            if (this.id > 0) {
                this.getData()
            } else {
                this.ruleForm.type = '1'
            }
        },
        methods: {
            returnpage() {
                this.$router.go(-1)
            },
            getData() {
                getInfo({id: this.id}).then(res => {
                    console.log(res)
                    const data = res.data
                    this.ruleForm.id = data.info.id
                    this.ruleForm.type = data.info.type.toString()
                    this.ruleForm.address = data.info.address

                }).catch(_ => {

                })
            },
            submitForm() {
                if (this.ruleForm.address.length < 10) {
                    this.$message.error(this.$t('account.input_right_wallet_address'))
                    return false
                }
                if (this.ruleForm.pay_password.length == 0) {
                    this.$message.error(this.$t('account.input_trader_password'))
                    return false
                }

                this.submit()
            },
            submit() {
                let params = {...this.ruleForm}
                let that = this
                addOrUpdate(params).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg)
                        setTimeout(function () {
                            that.returnpage();
                        }, 500);
                    } else {
                        this.$message.error(res.msg)
                    }

                }).catch(_ => {

                })

            },
            handleSuccess() {

            },
            handleRemove() {

            }
        }
    }
</script>
<style lang="scss" scoped>
    .addBag {
        font-size: 18px;

        .accctit {
            font-size: 24px;
            font-weight: bold;
            line-height: 80px;
        }

        .tiplin {
            line-height: 40px;
        }

        .marr {
            text-align: center;
            line-height: 26px;

            img {
                width: 200px;
                height: 200px;
                margin-right: 30px;
            }
        }

        .gzimgbox {
            width: 60%;
            margin: 20px auto;
        }

        .examplelistbox {
            img {
                width: 300px;
                height: 600px;
            }
        }

        .formbox {
            width: 60%;
            margin: 30px auto;
            padding: 30px;
            border-radius: 20px;
            border: 1px solid rgb(85, 85, 85);

            .bgb {
                margin: 40px 0px 20px 0px;
                padding: 14px 30px;
                background: #1750cc;
                color: #fff;
                font-size: 20px;
            }
        }
    }

</style>
